import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { ErrorResponse, useRouteError } from "react-router";

import { Error404 } from "./404";
import { Error500 } from "./500";

export const ErrorBoundary = () => {
  const error = useRouteError() as ErrorResponse;

  // Send error to Sentry
  useEffect(() => {
    captureException(error);
  }, [error]);

  // TrackJS picks this up
  console.error(error);

  return [404, 410].includes(error.status) ? <Error404 /> : <Error500 />;
};
